export interface BuildViewOperation {
  type: string;
  status: string;
}

/**
 * Once a full-site plan opens the working screen, stay there until the site
 * is built. A finished plan that has not started building continues on that
 * screen instead of returning to chat for a yes or no.
 */
export function viewAfterProgress(input: {
  isStreaming: boolean;
  phase?: string;
  hasCompletion: boolean;
  hasError: boolean;
  operations: BuildViewOperation[];
  continuedBuild: boolean;
}): { view: 'chat' | 'progress' | 'complete'; continueBuild: boolean } {
  if (input.isStreaming) return { view: 'progress', continueBuild: false };
  if (input.phase === 'complete' && input.hasCompletion) {
    return { view: 'complete', continueBuild: false };
  }
  if (input.hasError) return { view: 'chat', continueBuild: false };

  const planReady = input.operations.some(
    operation => operation.type === 'propose_site_plan' && operation.status === 'completed'
  );
  const buildStarted = input.operations.some(operation => operation.type === 'build_site');
  if (planReady && !buildStarted) {
    return { view: 'progress', continueBuild: !input.continuedBuild };
  }

  return { view: 'chat', continueBuild: false };
}
